import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'pt-BR',
  months: [
    'janeiro',
    'fevereiro',
    'março',
    'abril',
    'maio',
    'junho',
    'julho',
    'agosto',
    'setembro',
    'outubro',
    'novembro',
    'dezembro',
  ],
  monthsShort: ['jan.', 'fev.', 'mar.', 'abr.', 'mai.', 'jun.', 'jul.', 'ago.', 'set.', 'out.', 'nov.', 'dez.'],
  weekdays: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
  weekdaysMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  weekdaysShort: ['dom.', 'seg.', 'ter.', 'qua.', 'qui.', 'sex.', 'sáb.'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D [de] MMMM [de] YYYY',
    'LL-D': 'MMMM [de] YYYY',
    'LL-Y': 'D [de] MMMM',
    LLL: 'D [de] MMMM [de] YYYY, HH:mm',
    'LLL-Y': 'D [de] MMMM, HH:mm',
    LLLL: 'dddd, D [de] MMMM [de] YYYY, HH:mm',
    'LLLL-Y': 'dddd, D [de] MMMM, HH:mm',
    l: 'DD/MM/YYYY',
    'l-Y': 'DD/MM',
    ll: 'D [de] MMM [de] YYYY',
    'll-Y': 'D [de] MMM',
    'll-D': 'MMM [de] YYYY',
    lll: 'D [de] MMM [de] YYYY, HH:mm',
    'lll-Y': 'D [de] MMM, HH:mm',
    llll: 'ddd, D [de] MMM [de] YYYY, HH:mm',
    'llll-Y': 'ddd, D [de] MMM, HH:mm',
    'll-Y+w': 'ddd, D [de] MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D [de] MMMM [de] YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'a.m.', pm: 'p.m.', AM: 'a.m.', PM: 'p.m.' },
  past: {
    y: { one: 'há %s ano', other: 'há %s anos' },
    M: { one: 'há %s mês', other: 'há %s meses' },
    w: { one: 'há %s sem.', other: 'há %s sem.' },
    d: { one: 'há %s dia', other: 'há %s dias' },
    h: { one: 'há %s h', other: 'há %s h' },
    m: { one: 'há %s min.', other: 'há %s min.' },
    s: { one: 'há %s seg.', other: 'há %s seg.' },
  },
  future: {
    y: { one: 'em %s ano', other: 'em %s anos' },
    M: { one: 'em %s mês', other: 'em %s meses' },
    w: { one: 'em %s sem.', other: 'em %s sem.' },
    d: { one: 'em %s dia', other: 'em %s dias' },
    h: { one: 'em %s h', other: 'em %s h' },
    m: { one: 'em %s min.', other: 'em %s min.' },
    s: { one: 'em %s seg.', other: 'em %s seg.' },
  },
  pastLong: {
    y: { one: 'há %s ano', other: 'há %s anos' },
    M: { one: 'há %s mês', other: 'há %s meses' },
    w: { one: 'há %s semana', other: 'há %s semanas' },
    d: { one: 'há %s dia', other: 'há %s dias' },
    h: { one: 'há %s hora', other: 'há %s horas' },
    m: { one: 'há %s minuto', other: 'há %s minutos' },
    s: { one: 'há %s segundo', other: 'há %s segundos' },
  },
  futureLong: {
    y: { one: 'em %s ano', other: 'em %s anos' },
    M: { one: 'em %s mês', other: 'em %s meses' },
    w: { one: 'em %s semana', other: 'em %s semanas' },
    d: { one: 'em %s dia', other: 'em %s dias' },
    h: { one: 'em %s hora', other: 'em %s horas' },
    m: { one: 'em %s minuto', other: 'em %s minutos' },
    s: { one: 'em %s segundo', other: 'em %s segundos' },
  },
  abbr: {
    y: { one: '%s ano', other: '%s anos' },
    M: { one: '%s mês', other: '%s meses' },
    w: { one: '%s sem.', other: '%s sem.' },
    d: { one: '%s dia', other: '%s dias' },
    h: { one: '%sh', other: '%sh' },
    m: { one: '%s min', other: '%s min' },
    s: { one: '%ss', other: '%ss' },
  },
  full: {
    y: { one: '%s ano', other: '%s anos' },
    M: { one: '%s mês', other: '%s meses' },
    w: { one: '%s semana', other: '%s semanas' },
    d: { one: '%s dia', other: '%s dias' },
    h: { one: '%s hora', other: '%s horas' },
    m: { one: '%s minuto', other: '%s minutos' },
    s: { one: '%s segundo', other: '%s segundos' },
  },
  justNow: 'Agora mesmo',
  yesterday: 'Ontem',
  today: 'Hoje',
  tomorrow: 'Amanhã',
  weekStart: 0,
  timeRange: '%$1s–%$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D [de] MMMM [de] YYYY', end: 'D [de] MMMM [de] YYYY' },
    'yl-1': { start: 'D [de] MMMM', end: 'D [de] MMMM [de] YYYY' },
    ml: { start: 'D [de] MMMM', end: 'D [de] MMMM' },
    'ml-1': { start: 'D', end: 'D [de] MMMM [de] YYYY' },
    dl: { start: 'D', end: 'D [de] MMMM' },
    y: { start: 'D [de] MMM [de] YYYY', end: 'D [de] MMM [de] YYYY' },
    'y-1': { start: 'D [de] MMM', end: 'D [de] MMM [de] YYYY' },
    m: { start: 'D [de] MMM', end: 'D [de] MMM' },
    'm-1': { start: 'D', end: 'D [de] MMM [de] YYYY' },
    d: { start: 'D', end: 'D [de] MMM' },
    Y: { start: 'ddd, D [de] MMM [de] YYYY', end: 'ddd, D [de] MMM [de] YYYY' },
    'Y-1': { start: 'ddd, D [de] MMM', end: 'ddd, D [de] MMM [de] YYYY' },
    M: { start: 'ddd, D [de] MMM', end: 'ddd, D [de] MMM' },
    D: { start: 'ddd, D [de] MMM', end: 'ddd, D [de] MMM' },
    yt: { start: 'D [de] MMM [de] YYYY, HH:mm', end: 'D [de] MMM [de] YYYY, HH:mm' },
    mt: { start: 'D [de] MMM, HH:mm', end: 'D [de] MMM, HH:mm' },
    dt: { start: 'D [de] MMM, HH:mm', end: 'D [de] MMM, HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D [de] MMM [de] YYYY, HH:mm', end: 'D [de] MMM [de] YYYY, HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D [de] MMM, HH:mm', end: 'D [de] MMM, HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D [de] MMM, HH:mm', end: 'D [de] MMM, HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'pt-BR';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}º`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'a.m.' : 'a.m.';
    } else {
      return isLowerCase ? 'p.m.' : 'p.m.';
    }
  },
};
